import { bodyLock, bodyUnlock } from './lockScroll'

// Управление состоянием меню и прокруткой вместе
export function toggleMenu() {
  const html = document.documentElement
  if (html.classList.contains('menu-open')) {
    html.classList.remove('menu-open')
    bodyUnlock()
  } else {
    html.classList.add('menu-open')
    bodyLock()
  }
}

export function openMenu() {
  document.documentElement.classList.add('menu-open')
  bodyLock()
}

export function closeMenu() {
  document.documentElement.classList.remove('menu-open')
  bodyUnlock()
}
